import styles from "./garage-mentality.module.scss";
import Layout from "../../components/layout";
import Link from "next/link";
import Image from "next/image";
import Button from "../../components/atoms/button/Button";
import useIsomorphicLayoutEffect from "../../hooks/useIsomorphicLayoutEffect";

export default function GarageMentalityPage() {
  useIsomorphicLayoutEffect(() => {
    if (document && document.querySelector("#__next")) {
      // @ts-ignore
      document.querySelector("#__next").className = "hide-scrollbar";

      return () => {
        // @ts-ignore
        document.querySelector("#__next").className = "";
      };
    }
  }, []);

  return (
    <Layout className={styles.root}>
      <div className={styles.content}>
        <div className={styles.imageContainer}>
          <Image
            src="/assets/images/garage_bg.jpg"
            alt="Werkplaats in een garage met een geparkeerde Porsche"
            fill
          />
        </div>
        <div className={styles.textContainer}>
          <h1 className={styles.heading}>Garage Mentality</h1>

          <p>
            De ultieme sportwagen creëren: dat ging niet vanzelf. Voor het
            ontstaan van de eerste Porsche was een ondernemende mentaliteit
            nodig. Een droom realiseren vraagt om veerkracht. Door niet op te
            geven, werd in de garage vanuit een ruwe schets een iconisch
            sportwagenmerk geboren. Bij Porsche noemen we deze instelling daarom
            de Garage Mentality. Die staat voor ondernemerschap, ambitie en
            innovatie.
          </p>
          <p>
            De wereld is altijd klaar voor nieuwe dromen en de verfrissende
            ideeën die daaruit voortkomen. Voor veel ambitieuze dromers is de
            garage de plek waar die ideeën vorm krijgen en verandering in gang
            wordt gezet.
          </p>
          <p>
            Dromen zijn niet te timen, het realiseren ervan wel. Doe het nu:
            maak werk van jouw droom en daarmee misschien wel van je nieuwe
            onderneming. Laat je met behulp van AI inspireren door succesvolle
            ondernemers. Durf te vragen, je krijgt direct een antwoord.
          </p>

          <Link href={"/#ai"}>
            <Button
              label={`Stel nu een vraag en \nontdek jouw Garage Mentality`}
              className={styles.button}
            />
          </Link>
        </div>
      </div>
    </Layout>
  );
}
